import { ApiClient } from "@/services/apiClient";
import { z } from "zod";
import { type PaymentMethod } from "./paymentMethodTypes";
import { PaymentMethod_Schema } from "./paymentMethodSchema";

const ApiResponse_PaymentsList_Schema = z.object({ payments: PaymentMethod_Schema.array() });
type ApiResponse_PaymentsList = z.infer<typeof ApiResponse_PaymentsList_Schema>;

export const fetchPaymentMethods = async (): Promise<PaymentMethod[]> => {
  const url = "api/payment/payment";
  return ApiClient.get<ApiResponse_PaymentsList>(url).then(({ data }) => ApiResponse_PaymentsList_Schema.parse(data).payments);
};
